var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html, nothing } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { BaseComponent } from '../../utils/BaseComponent';
import { t } from 'i18next';
let Completed = class Completed extends BaseComponent {
    render() {
        return html `
      <div data-test='done' class="flex justify-center flex-col items-center text-center gap-16">
        <trust-icon label=${t('CompleteIconAriaLabel')} name="Medal" classNames="w-[5rem], h-[5rem]"></trust-icon>
        <h1> ${t('Thanks for your answers')}</h1>
        <p>${t('This will help us improve')}</p>
        ${this.completedUrl ? html `<a class='m-auto block align-center text-link cursor-pointer hover:text-link--hover hover:underline focus:text-link--hover focus:underline mt-4' href='${this.completedUrl}'>${t('Done')}</a>` : nothing}
      </div>
    `;
    }
};
__decorate([
    property()
], Completed.prototype, "completedUrl", void 0);
Completed = __decorate([
    customElement('trust-completed')
], Completed);
export { Completed };
//# sourceMappingURL=Completed.js.map